import React from "react";
import { Button, makeStyles } from "@fluentui/react-components";
import Stack from "./Stack";
import { useTranslation } from "react-i18next";

const useStyles = makeStyles({
  root: {
    background: "white",
    width: "100%",
    position: "fixed",
    bottom: "0",
    left: "0",
    boxSizing: "border-box",
    padding: "15px",
  },
});

function ConfirmationButton(props) {
  const styles = useStyles();
  const { t } = useTranslation();
  const {
    onUserSelectsRoom = () => { },
    showConfirmationButton = false
  } = props;

  return (
    <Stack
      className={styles.root}
      direction="column" gap="16px"
      style={{ display: showConfirmationButton ? "flex" : "none" }}>
      <Button appearance="primary" onClick={onUserSelectsRoom}>
        {t("Add selected room")}
      </Button>
    </Stack>
  )
}

export default ConfirmationButton;